import { Box, Typography, Card, Stack, Chip, Fab, Alert } from "@mui/material";
import Add from "@mui/icons-material/Add";
import BarChartRounded from "@mui/icons-material/BarChartRounded";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import { STOCKS_LISTS } from "@/data/mock-data";
import { BotsMarketplaceToggle } from "@/components/BotsMarketplaceToggle";

export function ListsPage() {
  const navigate = useNavigate();

  return (
    // `px: 2` gutter — matches AccountsPageV2; MobileShellV2 renders
    // pages edge-to-edge so each page owns its horizontal padding.
    <Box sx={{ maxWidth: 720, mx: "auto", position: "relative", px: 2, pt: 1 }}>
      <BotsMarketplaceToggle />
      <Alert severity="info" variant="outlined" sx={{ mb: 3, borderRadius: 3 }}>
        Example lists provided by White Hat Bots are for educational purposes only — not investment advice.
      </Alert>

      <Stack spacing={1.25}>
        {STOCKS_LISTS.map((list) => (
          <Card
            key={list.id}
            onClick={() => navigate(`/lists/${list.id}`)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              cursor: "pointer",
              "&:hover": { bgcolor: "action.hover" }
            }}
          >
            <Box sx={{
              width: 40, height: 40, borderRadius: 2,
              bgcolor: "rgba(77,163,255,0.16)", color: "secondary.main",
              display: "grid", placeItems: "center"
            }}>
              <BarChartRounded />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography fontWeight={700} noWrap>{list.name}</Typography>
              <Typography variant="caption" color="text.secondary" noWrap>
                {list.tickers.slice(0, 5).join(", ")}
                {list.tickers.length > 5 ? `, +${list.tickers.length - 5} more` : ""}
              </Typography>
            </Box>
            <Chip label={list.creator} size="small" variant="outlined" />
            <KeyboardArrowRight sx={{ color: "text.secondary" }} />
          </Card>
        ))}
      </Stack>

      <Fab
        color="primary"
        variant="extended"
        sx={{
          position: "fixed",
          right: 16,
          bottom: { xs: "calc(80px + env(safe-area-inset-bottom))", md: 24 }
        }}
      >
        <Add sx={{ mr: 1 }} /> Create list
      </Fab>
    </Box>
  );
}
